import api from '../../services/primaryContentCompleted';
export default function (helper) {

  /**
   * Generated store module
   */
  helper.setApi(api);
  const types = helper.types('primary_content_completed');
  const state = helper.state();
  const getters = helper.getters();
  const actions = helper.actions({}, 'Primary Content Completed');
  const mutations = helper.mutations({}, types, state);

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
}